/* WINGBABE · sticky-header · vanilla JS, no dependencies */
(function(){
function set(){var h=document.querySelector('header[data-section="header"]');if(h)document.documentElement.style.setProperty('--header-h',h.offsetHeight+'px');}
set();window.addEventListener('load',set);window.addEventListener('resize',set);if(document.fonts)document.fonts.ready.then(set);
})();
